var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgModelOverviewIcon = function SvgModelOverviewIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M11.525 12.131c3.52-3.517 5.22-7.52 3.798-8.942-1.422-1.421-5.429.278-8.95 3.795s-5.22 7.521-3.797 8.943c1.422 1.42 5.429-.278 8.949-3.796Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeMiterlimit: 10,
    d: "M15.424 15.811c1.423-1.421-.278-5.425-3.798-8.942S4.1 1.652 2.676 3.073c-1.422 1.422.279 5.425 3.8 8.943s7.526 5.216 8.948 3.795Z"
  })));
};
export default SvgModelOverviewIcon;